<template>
  <div ref="myRef" class="search-bar-container" :class="{ 'mb-5': desktopView, 'py-5': desktopView, 'py-3': mobileView }">
    <div class="row">
      <div class="large-3 columns" v-if="desktopView">
      </div>
      <div class="columns" :class="{ 'large-9': desktopView, 'large-12': mobileView }">
        <div class="flex-row">
          <div
            class="search-field-wrapper flex-row align-items-stretch mr-4"
            :class="{ focused: inputIsFocused }">

            <span v-if="desktopView" class="align-items-center" @click="focusSearchInput">
              <font-awesome-icon icon="search" class="pl-4 pr-2 search-icon"></font-awesome-icon>
            </span>

            <input type="text"
              ref="queryInput"
              :placeholder="placeholder"
              @keyup.enter="submit"
              @focus="inputFocused"
              @blur="inputBlured"
              v-model="query">

            <a
              href="#"
              @click.prevent="clearQuery"
              v-if="query"
              class="px-4 align-items-center clear-query"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div>
            <button @click="submit">
              <template v-if="mobileView">
                <font-awesome-icon icon="search"></font-awesome-icon>
              </template>

              <template v-else>
                <span class="px-4">Search</span>
              </template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { useStore } from 'vuex';
  import { ref, computed } from 'vue';

  import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue';

  import useIsMobile from '@/scripts/use_is_mobile';

  export default {
    name: "SearchBar",

    components: {
      FontAwesomeIcon
    },

    props: ['myRef'],

    setup() {
      const store = useStore();

      const inputIsFocused = ref(false);

      const { mobileView, desktopView } = useIsMobile();

      const queryInput = ref(null);

      return {
        query: computed({
          get() { return store.getters["filters/getQuery"]; },
          set(value) { store.dispatch("filters/updateQuery", value); }
        }),

        clearQuery() {
          store.dispatch("filters/clearQuery");
          store.dispatch("hackathons/search");
        },

        submit() {
          store.dispatch("hackathons/searchByKeywords");
          queryInput.value.blur();
        },

        inputIsFocused,

        inputFocused: () => inputIsFocused.value = true,

        inputBlured: () => inputIsFocused.value = false,

        placeholder: computed(() => {
          if (desktopView.value) {
            return "Search by hackathon title or keyword";
          } else {
            return "Search hackathons";
          }
        }),

        queryInput,

        focusSearchInput() {
          queryInput.value.focus();
        },

        mobileView,
        desktopView
      }
    }
  }
</script>

<style scoped lang="scss">
  .search-bar-container {
    .is-mobile & {
      background: white;
    }
  }

  .is-desktop {
    padding-left: 2rem;
    padding-right: 2rem;
  }
</style>
